import { formatINR } from "@templeos/shared";
import { useEffect, useState } from "react";
import { QrImage } from "../components/PrintArea.js";
import { DISPLAY_CHANNEL, type DisplayMessage } from "../lib/display.js";

const THANKS_MS = 6_000;

/** Customer-facing second screen (SOW Module 1): the bill, the amount due and the UPI QR, mirrored from the POS window. */
export function CustomerDisplay() {
  const [msg, setMsg] = useState<DisplayMessage | null>(null);
  useEffect(() => {
    document.title = "Customer display";
    if (typeof BroadcastChannel === "undefined") return;
    const ch = new BroadcastChannel(DISPLAY_CHANNEL);
    let timer: ReturnType<typeof setTimeout> | null = null;
    ch.onmessage = (e: MessageEvent<DisplayMessage>) => {
      setMsg(e.data);
      if (timer) clearTimeout(timer);
      if (e.data.type === "paid") {
        const name = e.data.templeName;
        timer = setTimeout(() => setMsg({ type: "idle", templeName: name }), THANKS_MS);
      }
    };
    return () => { if (timer) clearTimeout(timer); ch.close(); };
  }, []);

  const name = msg?.templeName ?? "Temple counter";
  return (
    <div className="tos-root pos-tv" style={{ justifyContent: "center" }}>
      <header className="pos-tv-head"><h1>{name}</h1></header>
      {(!msg || msg.type === "idle") && (
        <div style={{ textAlign: "center", fontSize: "4vw", fontWeight: 800 }}>
          <div>Welcome</div>
          <div lang="hi" style={{ fontSize: "3vw", color: "#f3c877" }}>आपका स्वागत है</div>
          <div lang="gu" style={{ fontSize: "3vw", color: "#f3c877" }}>આપનું સ્વાગત છે</div>
        </div>
      )}
      {msg?.type === "cart" && (
        <div style={{ display: "grid", gridTemplateColumns: msg.upi ? "1fr auto" : "1fr", gap: "3vw", alignItems: "start" }}>
          <div>
            <table className="pos-cd-lines"><tbody>
              {msg.lines.map((l, i) => <tr key={i}><td>{l.qty} × {l.name}</td><td>{formatINR(l.amount)}</td></tr>)}
            </tbody></table>
            <div style={{ fontSize: "2.4vw", marginTop: "2vw" }}>Amount to pay</div>
            <div className="pos-cd-total" aria-live="polite">{formatINR(msg.total)}</div>
          </div>
          {msg.upi && (
            <div style={{ textAlign: "center" }}>
              <QrImage value={msg.upi.link} alt={`UPI QR code for ${formatINR(msg.upi.amount)}`} size={420} className="pos-cd-qr" />
              <div style={{ fontSize: "2.2vw", marginTop: "1vw" }}>Scan with any UPI app to pay {formatINR(msg.upi.amount)}</div>
            </div>
          )}
        </div>
      )}
      {msg?.type === "paid" && (
        <div style={{ textAlign: "center" }} role="status">
          <div style={{ fontSize: "5vw", fontWeight: 900, color: "#9be3b4" }}>Thank you</div>
          <div style={{ fontSize: "3vw" }}>Paid {formatINR(msg.total)}{msg.number ? ` · Receipt ${msg.number}` : ""}</div>
          {msg.change ? <div style={{ fontSize: "3vw", color: "#f3c877" }}>Your change: {formatINR(msg.change)}</div> : null}
        </div>
      )}
    </div>
  );
}
